import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_KEY; // Use a secure key

class CryptoHelper {

     // Encrypting data
     encryptData(data) {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
     }

    // Decrypting data
     decryptData(ciphertext) {
        const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedData);
     }

}

export default new CryptoHelper();